import { useContext } from 'react';
import { StoreContext } from "@roc/feature-app-core"
import { ChangePasswordStore } from "../stores/changePasswordStore";

export const useChangePasswordStore = () => useContext<{
  changePasswordStore: ChangePasswordStore
}>(StoreContext);